export enum Routes {
  publicDashboard = "/",
  privateDashboard = "/private",
}
